import {
	DateFormatOptions,
	QuoteFormatOptions,
	SystemConnection,
	TagFieldFormatOptions,
	TimestampConversionOptions,
} from '@Types/systemConnections.types';

import {
	SECURITY_MODES_DEFAULT_EDIT,
	SECURITY_POLICIES_DEFAULT_EDIT,
} from '@Components/NewSystemConnectionForm/OpcuaTypes';

export function initialFormData(
	match: SystemConnection,
	isCredentialsOptional: boolean,
) {
	const timestampConversion =
		match.timestampConversion ||
		(match.dateTimeFormat === 'DD-MMM-YYYY' // ? Oracle
			? TimestampConversionOptions.TIMESTAMP_prefix.value
			: TimestampConversionOptions.IMPLICIT.value);

	const username = isCredentialsOptional ? match.username ?? '••••••••' : '';
	const password = isCredentialsOptional ? match.password ?? '••••••••' : '';
	const endpointMustExist =
		match?.endpointMustExist?.toString() === 'true' ? 'true' : 'false';

	return {
		username,
		password,
		connectionName: match.connectionName,
		serverType: match.serverType,
		connectionType: match.connectionType,
		timeout: (match.timeout ?? 30).toString(),
		serverAddress: match.serverAddress,
		connectionString: match.connectionString,
		database: match.database,
		port: match.port?.toString(),
		databaseTimezone: match.databaseTimezone,
		sampleDurationSeconds: match.sampleDurationSeconds?.toString(),
		queryLagMinutes: match.queryLagMinutes?.toString(),
		queryGroupSize: match.queryGroupSize?.toString(),
		caseSensitiveSensorId: match.caseSensitiveSensorId?.toString(),
		simulationSubtractionDays: match.simulationSubtractionDays?.toString(),
		dateTimeFormat: (
			match.dateTimeFormat || DateFormatOptions.ANSI.value
		).toString(),
		quoteFormat: (
			match.quoteFormat || QuoteFormatOptions.DOUBLE_QUOTE.value
		).toString(),
		resourcePath: match.resourcePath,
		opcuaUrl: match.opcuaUrl,
		editMode: 'true',
		tagFormat: match.tagFormat || TagFieldFormatOptions.STRING.value,
		timestampConversion: timestampConversion.toString(),
		securityMode: match.securityMode || SECURITY_MODES_DEFAULT_EDIT,
		securityPolicy: match.securityPolicy || SECURITY_POLICIES_DEFAULT_EDIT,
		endpointMustExist: endpointMustExist,
		sessionName: match.sessionName ?? '',
		queryPrefix: match.queryPrefix ?? '',
	};
}
